module.exports = __webpack_public_path__ + "img/puff-cloud.2e44f0b8.webp";